import { useMutation } from '@tanstack/react-query';
import { finishPractice } from '../queries/post';

export function useFinishPractice() {
  const { mutate, data, isPending, isError } = useMutation({
    mutationKey: ['finishPractice'], 
    mutationFn: (id: string) => finishPractice(id),
    retry: false
  });

  return { mutate, data, isPending, isError };
}
